import { render } from "./ButtonGroup.vue?vue&type=template&id=fb3e9b54"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import "./ButtonGroup.vue?vue&type=style&index=0&id=fb3e9b54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__